var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_c('VueApexCharts',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }